import EventsSearchPill from './EventsSearchPill';

export default EventsSearchPill;
